// cspell:ignore idna momo

export const MAX_INPUT_LENGTH = 50

// The regexes below are a port of marshmallow's `validate.Email` (exposed as
// `flytrex_utils.paragon.fields.Validate.Email`), which is what the oversight side validates
// emails against - both in the users admin form and in the dashboard_backend REST schemas.
// Keeping them identical means an address accepted here is accepted there as well.
// eslint-disable-next-line no-control-regex -- the quoted string form allows control characters
const USER_REGEX = /^(?:[-!#$%&'*+/=?^`{}|~\p{L}\p{N}_]+(?:\.[-!#$%&'*+/=?^`{}|~\p{L}\p{N}_]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f!#-[\]-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")$/iu

const DOMAIN_REGEX = /^(?:(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:[a-z]{2,6}|[a-z0-9-]{2,})|\[(?:25[0-5]|2[0-4]\d|[01]?\d?\d)(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}\])$/i

const DOMAIN_WHITELIST = ['localhost']

// marshmallow retries a domain that failed DOMAIN_REGEX after IDNA-encoding it, so that unicode
// domains are accepted. The browser does that encoding as part of parsing a URL.
// Domains holding characters the URL parser treats structurally are left alone, otherwise
// `momo.com/x` would be silently trimmed into the valid `momo.com`.
function idnaEncodedDomain(domain: string): string {
  // eslint-disable-next-line no-control-regex -- matching any non-ascii character
  if (!/[^\x00-\x7f]/u.test(domain) || /[\\/?#@:[\]]/u.test(domain)) {
    return domain
  }
  try {
    return new URL(`http://${domain}`).hostname
  } catch {
    return domain
  }
}

function isValidEmail(email: string): boolean {
  const atIndex = email.lastIndexOf('@')
  if (atIndex === -1) {
    return false
  }

  const userPart = email.slice(0, atIndex)
  const domainPart = email.slice(atIndex + 1)

  if (!USER_REGEX.test(userPart)) {
    return false
  }

  return DOMAIN_WHITELIST.includes(domainPart) ||
    DOMAIN_REGEX.test(domainPart) ||
    DOMAIN_REGEX.test(idnaEncodedDomain(domainPart))
}

// Shared by the users form and the center notifications contact list, so that an email
// is considered valid in exactly the same way everywhere.
export function emailValidationMessage(email: string, saveInProgress: boolean): string {
  if (email.length > MAX_INPUT_LENGTH) {
    return `*This field is limited to ${MAX_INPUT_LENGTH} characters`
  }
  if (saveInProgress && email.length === 0) {
    return `*Required field`
  }
  if (saveInProgress && !isValidEmail(email)) {
    return '*Email is invalid'
  }
  return ``
}
